
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h900v600H0z"}}),_c('g',{attrs:{"transform":"rotate(-56.31)"}},[_c('g',{attrs:{"stroke":"#000","stroke-width":"25"}},[_c('path',{attrs:{"d":"M-75 228.3H75m-150 37.5H75m-150 37.5H75M-75 778.3H75m-150 37.5H75m-150 37.5H75"}})]),_c('path',{attrs:{"stroke":"#FFF","stroke-width":"12.5","d":"M0 753.3v125"}}),_c('circle',{attrs:{"fill":"#ca163a","cy":"540.8","r":"150"}}),_c('path',{attrs:{"fill":"#0e4896","d":"M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"}})]),_c('g',{attrs:{"stroke":"#000","stroke-width":"25"}},[_c('path',{attrs:{"d":"M231.56 535.73l-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006l-83.205-124.808M689.187 230.644l-83.205-124.807M720.39 209.843L637.184 85.036m114.407 104.006L668.386 64.234"}})]),_c('path',{attrs:{"stroke":"#FFF","stroke-width":"12.5","d":"M205.6 462.897l31.202-20.8m389.981-259.989l36.444-24.296m31.202-20.801l31.202-20.801"}})])
          )
        }
      }
    